import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { siteMap } from "internal-sitemap";
import SubscriptionType from "organisms/enums/subscription-type";
import React from "react";
import { useHistory } from "react-router-dom";
import { RouteUtils } from "utilities/route-utils";
import SubscriptionTypeUtils from "utilities/subscription-type-utils";
import { t } from "utilities/localization-utils";

const SharedPublicPageFooter: React.FC = () => {
    const BASE_CSS_CLASSNAME = "c-shared-public-page-footer";
    const history = useHistory();
    const freeAccessRoute = RouteUtils.getUrl(
        siteMap.signup.registerPlanSelected,
        {
            subscriptionType: SubscriptionTypeUtils.toRouteParam(
                SubscriptionType.FreeTrial
            ),
        }
    );

    return (
        <footer className={`${BASE_CSS_CLASSNAME}`}>
            <div className={`${BASE_CSS_CLASSNAME}__content`}>
                <div className={`${BASE_CSS_CLASSNAME}__text`}>
                    {t("thisIsALiveDocumentSubjectToChange")}
                </div>
                <div className={`${BASE_CSS_CLASSNAME}__action`}>
                    <Button
                        style={ButtonStyles.Secondary}
                        onClick={() => history.push(freeAccessRoute)}>
                        {t("tryAFreeTrial")}
                    </Button>
                </div>
            </div>
        </footer>
    );
};

export default SharedPublicPageFooter;
